<template>
  <div>
    <input
      type="file"
      ref="files"
      class="d-none"
      :multiple="multiple"
      @change="loadFiles"
    />
    <md-button
      v-if="multiple || !files.length"
      :class="btnClass"
      :disabled="loadingFile || loading || disabled"
      @click="fileAction"
    >
      <md-icon v-if="icon">{{ icon }}</md-icon> {{ label }}
    </md-button>
    <template v-if="showLoadedFiles">
      <div class="file-card" v-for="(file, index) in files" :key="index">
        <p>
          {{ file.name }}
        </p>
        <button
          v-if="!(disabled || loading)"
          class="btn-action"
          @click="deleteFile(index)"
        >
          X
        </button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FileField',
  props: {
    exe: {
      type: Function,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: 'Cargar archivo'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    allowFileFormats: {
      type: Array,
      required: false,
      default: () => ['pdf']
    },
    btnClass: {
      type: String,
      required: false,
      default: 'info'
    },
    multiple: {
      default: false,
      type: Boolean,
      required: false
    },
    icon: {
      default: '',
      type: String,
      required: false
    },
    showLoadedFiles: {
      default: false,
      type: Boolean,
      required: false
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      loadingFile: false,
      files: [],
    }
  },
  methods: {
    fileAction() {
      if (this.exe) {
        this.exe()
        return
      }
      this.$refs.files.multiple = this.multiple
      this.$refs.files.click()
    },
    loadFiles() {
      const files = [...this.$refs.files.files]
      this.$refs.files.value = null
      let filteredFiles = []
      if (
        files.some((f) => {
          const format = f.name.split('.').pop().toLowerCase()
          return !this.allowFileFormats.includes(format.toLowerCase())
        })
      ) {
        this.$alertMessage({
          title: 'Hay archivos de formatos no permitidos',
          text: `Formatos: ${this.allowFileFormats.join(', ')}`
        })
      }

      if (files.some((f) => f.size > 12000000)) {
        this.$alertMessage({
          title: 'Algunos archivos pesan más de 12 MB'
        })
      }
      filteredFiles = files.filter((f) => {
        const format = f.name.split('.').pop().toLowerCase()
        return (
          f.size <= 12000000 &&
          this.allowFileFormats.includes(format.toLowerCase())
        )
      })
      this.files = [...this.files, ...filteredFiles]
      if (this.multiple) {
        this.$emit('input', this.files)
        return
      }
      this.$emit('input', this.files[0])
    },
    deleteFile(index) {
      if (this.multiple) {
        this.files.splice(index, 1)
        this.$emit('input', this.files)
        return
      }
      this.$refs.files.value = null
      this.files = []
      this.$emit('input', null)
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        if (!newVal || !newVal.length) {
          this.files = []
        }
      }
    },
    files: {
      deep: true,
      handler(newVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.d-none {
  display: none;
}
.file-card {
  display: flex;
  margin: 0 5px;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: rgb(223, 223, 223);
  width: 200px;
  p {
    margin: 0 auto;
    text-align: center;
    align-content: center;
    white-space: nowrap;
    width: 80%;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .btn-action {
    color: #ff0000;
    margin: auto;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inputs/FileField.vue